export const USER_ROLES = {
    ADMIN: 'admin',
    USER: 'user',
    AGENCY: 'agency',
    ACCOUNT: 'account',
};
export const GHLLanguageKeysMapper = {
    en_US: 'en-US',
    da: 'da',
    nl: 'nl',
    fi: 'fi',
    fr_FR: 'fr-FR',
    fr_CA: 'fr-CA',
    de: 'de',
    it: 'it',
    no: 'nb',
    pt_PT: 'pt-PT',
    pt_BR: 'pt-BR',
    es: 'es',
    sv: 'sv',
};
export const VIEW_OPTIONS = [
    { name: 'timeGridDay', tab: 'day', title: 'Day', value: 'timeGridDay' },
    { name: 'timeGridWeek', tab: 'week', title: 'Week', value: 'timeGridWeek' },
    { name: 'dayGridMonth', tab: 'month', title: 'Month', value: 'dayGridMonth' },
];
export const FILTER_OPTIONS = [
    { label: 'All', key: 'All' },
    { label: 'Appointment', key: 'Appointment' },
    { label: 'Blocked Slots', key: 'Blocked Slots' },
];
export const SELECTION_COLORS = [
    '#004EEB',
    '#027A48',
    '#026AA2',
    '#C11574',
    '#3538CD',
    '#C01048',
    '#5925DC',
    '#E62E05',
    '#175CD3',
    '#363F72',
];
export const BOOKED_STATUS = 'booked';
export const NEW_APPOINMENT = 'new';
export const CONFIREMED_APPOINMENT = 'confirmed';
export const CANCELLED_APPOINMENT = 'cancelled';
export const INVALID_APPOINMENT = 'invalid';
export const SHOWED_APPOINMENT = 'showed';
export const NO_SHOW_APPOINMENT = 'noshow';
// export const AVAILAIBLE_STATUS = 'available'
// export const UNAVAILAIBLE_STATUS = 'unavailable'
export function ACTIVE_VIEW_LS_KEY_FN(locationId, userId) {
    return `fc_active_view_${locationId}` + (userId ? `_${userId}` : '');
}
export function ACTIVE_USERS_LS_KEY_FN(locationId, userId) {
    return `fc_active_user_ids_${locationId}` + (userId ? `_${userId}` : '');
}
export function ACTIVE_CALENDARS_LS_KEY_FN(locationId, userId) {
    return `fc_active_calendar_ids_${locationId}` + (userId ? `_${userId}` : '');
}
export function ACTIVE_GROUPS_LS_KEY_FN(locationId, userId) {
    return `fc_active_group_ids_${locationId}` + (userId ? `_${userId}` : '');
}
export function ACTIVE_TAB_SELECTION_FN(locationId, userId) {
    return `fc_selecetd_tab_${locationId}` + (userId ? `_${userId}` : '');
}
export const FullCalendarLanguageKeysMapper = {
    en_US: 'en-us',
    da: 'da',
    nl: 'nl',
    fi: 'fi',
    fr_FR: 'fr',
    fr_CA: 'fr-ca',
    de: 'de',
    it: 'it',
    no: 'nb',
    pt_PT: 'pt',
    pt_BR: 'pt-br',
    es: 'es',
    sv: 'sv',
};
